import { hashtagTextRegex, hashtagWithHashRegex } from './hashtagRegex';
export function indexOfFirstInvalidHashtagCharacter(text) {
    const characters = text.split('');
    return characters.findIndex((value)=>!validateHashtagText(value));
}
export function validateHashtagText(text) {
    return hashtagTextRegex.test(text);
}
export function validateHashtag(textWithHash) {
    return hashtagWithHashRegex.test(textWithHash);
}

//# sourceMappingURL=validateHashtag.js.map